import { QueryParam } from "../types/api/generic.type";

export const encodeQueryParamValue = (value: string): string => {
  const utf8Bytes = new TextEncoder().encode(value);
  let binary = "";
  utf8Bytes.forEach((byte) => {
    binary += String.fromCodePoint(byte);
  });

  return btoa(binary)
    .replaceAll("+", "-")
    .replaceAll("/", "_")
    .replace(/=+$/, "");
};

export const decodeQueryParamValue = (value: string | null): string | null => {
  if (value === null) {
    return null;
  }

  try {
    const base64 = value.replaceAll("-", "+").replaceAll("_", "/");
    const binary = atob(base64);
    const bytes = Uint8Array.from(binary, (char) => char.codePointAt(0) ?? 0);

    return new TextDecoder().decode(bytes);
  } catch {
    return value;
  }
};

export const DETAIL_QUERY_PARAM_KEY = "d";

export type DetailQueryParams = {
  collaboratorName?: string;
  collaboratorSurname?: string;
  careerManagerName?: string;
  careerManagerSurname?: string;
};

export const encodeParams = (params: DetailQueryParams): string =>
  encodeQueryParamValue(JSON.stringify(params));

export const decodeParams = (raw: string | null): DetailQueryParams => {
  const decoded = decodeQueryParamValue(raw);

  if (!decoded) {
    return {};
  }

  try {
    return JSON.parse(decoded) as DetailQueryParams;
  } catch {
    return {};
  }
};

export const createQueryParamString = (
  params: QueryParam[],
  atPathStart: boolean = false,
): string => {
  const queryString = params
    .filter((param) => param.value.length > 0) // Exclude empty value arrays
    .map(
      (param) =>
        `${encodeURIComponent(param.key)}=${param.value.map((val) => encodeURIComponent(val)).join(",")}`,
    )
    .join("&");

  return queryString ? `${atPathStart ? "?" : "&"}${queryString}` : "";
};
